const formateUser = (val) => {
  let label = '议价人'
  switch (val) {
    case '2':
      label = '合伙人'
      break;
    case '3':
      label = '平台'
      break;
    case '4':
      label = '投资人'
      break;
  }
  return label
}

const formatJg = (val) => {
  let label = ''
  switch (val) {
    case '0':
      label = '组件'
      break;
    case '1':
      label = '逆变器'
      break;
    case '2':
      label = '组件+逆变器'
      break;
  }
  return label
}

const formateRoof = (val) => {
  let label = ''
  switch (val) {
    case '0':
      label = '彩瓦钢'
      break;
    case '1':
      label = '水泥顶'
      break;
    case '2':
      label = '瓦房'
      break;
    case '3':
      label = '彩瓦钢+水泥顶'
      break;
    case '4':
      label = '其他'
      break;
  }
  return label
}

export default {
  formateUser,
  formatJg,
  formateRoof
}